import React, { Component } from 'react';
import './features.css';
import { Link } from 'react-router-dom';


class Features extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            feat: []                
        };
      }

      componentDidMount() {
        this.getFeat();
      }

    componentDidUpdate(){

      }

      getFeat = () => {

        fetch(('/api/features'))
        .then(res => res.json())
        .then(data => this.setState({
                    feat: data.feat
                    }));
      }

 
    render() {
        const { feat } = this.state;
        return (
            <React.Fragment>
                {feat.length ? (
                    <React.Fragment>
                        <div className="fullWidth fullHeight featStage bgCover" style={{backgroundImage: `url(${feat[0].images[0].imgURL})`}}>
                            {feat.map((feat, i)=>{
                                return(
                                        <div className="newsFeature floatLeft" key={i}>      
                                            <div className="featureDes marginTopStart" >
                                                <h1>{feat.featTitle}
                                                </h1>
                                                <Link to={"/features/"+feat.featName} key={i+1}>
                                                <div className="buttonCTA buttonText">
                                                <p>READ MORE</p>
                                                </div>
                                                </Link>
                                            </div>
                                        </div>   
                                );
                            }
                            )}
                        </div>
                    </React.Fragment>
                ):( 
                    <div className="fullWidth fullHeight redT blinkFast loader">
                        <div className="centeredContent">•</div>
                    </div>
            )

                }
            </React.Fragment>
        )
    }
  }
  
  export default Features;






// WEBPACK FOOTER //
// ./src/components/features/features.js